<template>
  <div class="this-ad">
    <div class="ad-mark">广告</div>
    <h3 class="ad-title">修正春季广告</h3>
    <div class="ad-profit">
      已收益
      <span>200.00</span>个
      预计收益
      <span>200.00</span>个
    </div>
    <div class="date">2019.01.01-12:30 至 2019.06.01-12:30</div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {},

  async created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.this-ad {
  position: relative;
  margin: 0 auto;
  padding: 20px 0 0;
  width: 345px;
  /* height: 120px; */
  height: 100px;
  background: rgba(254, 250, 241, 1);
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  border: 1px solid rgba(240, 217, 159, 1);
  text-align: center;
}

.ad-mark {
  position: absolute;
  top: 0;
  left: 0;
  width: 55px;
  height: 28px;
  display: inline-block;
  background-image: url(~@/icons/ad/ad-mark.png);
  background-repeat: no-repeat;
  background-size: contain;

  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  line-height: 22px;
  text-align: center;
}

.ad-title {
  margin: 0 0 14px 0;
  padding: 0;
  height: 24px;
  font-size: 17px;
  font-weight: 600;
  color: #41424e;
  line-height: 24px;
}

.ad-profit {
  margin-bottom: 9px;
  height: 18px;
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
  span {
    height: 17px;
    font-size: 15px;
    font-weight: bold;
    color: #41424e;
    line-height: 17px;
  }
}

.date {
  height: 16px;
  font-size: 11px;
  font-weight: 500;
  color: #999999;
  line-height: 16px;
}
</style>
